import { render, staticRenderFns } from "./AdimoButton.vue?vue&type=template&id=622d01da&"
import script from "./AdimoButton.vue?vue&type=script&lang=js&"
export * from "./AdimoButton.vue?vue&type=script&lang=js&"
import style0 from "./AdimoButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports